<template>
  <div class="collectionDetailGallery"
    :style="pageSetting">
    <button type="button" class="btnClose" @click.stop="close"></button>
    <div class="frame">
      <div v-if="breadCrumb && breadCrumb.length" class="name" :style="nameSpacing">
        <span v-for="path in breadCrumb"
          :key="path.categoryId"
          class="path">
          {{ path.categoryLabel[lang] }}
        </span>
        {{ detailItem.collectionItemName[lang] }}
      </div>
      <div v-if="detailItem.imageList.length > 0" class="imageList">
        <button v-if="isCollectableUser && collectionIcon"
          type="button"
          class="btnCollection"
          @click.stop="toggleCollection">
          <img :src="isMyCollection ? collectionIcon.active : collectionIcon.default" alt="" :style="{width: collectionIcon.size}">
        </button>
        <swiper
          :options="swiperOptions"
          ref="imageList"
          class="imageWrapper">
          <swiper-slide v-for="(img, index) in detailItem.imageList" :key="index">
            <div class="img"><img :src="img" alt=""></div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
        <div v-if="imgIndicator" class="imgIndicator">
          <span
            v-for="img in imgIndicator.length"
            :key="img"
            class="dot"
            :style="{backgroundColor: imgIndicator.color}"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'DetailGallery',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId',
    'isCollectableUser'
  ],
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    collectionItemId () {
      return this.$store.getters['collection/getDetailGallery']
    },
    getCategoryById () {
      return this.$store.getters['collection/getCategoryById'](this.categoryId)
    },
    isMyCollection () {
      return this.$store.getters['collection/getIsMyCollectionItem'](this.collectionItemId)
    },
    collectionIcon () {
      const setting = this.getCategoryById && this.getCategoryById.categorySetting
      const useCollection = setting && setting.useCollection
      const myCollectionSetting = this.$store.getters['collection/getMyCollectionSetting']
      const scrapIcon = myCollectionSetting && {
        ...myCollectionSetting.scrapIcon,
        size: `${myCollectionSetting.scrapIcon.size}px`
      }
      return useCollection && scrapIcon
    },
    breadCrumb () {
      const getCategoryListAll = this.$store.getters['collection/getCategoryListAll']
      function getBreadcrumbById (categoryId, categoryList) {
        const path = []
        function findPath(categories, targetId, currentPath) {
          for (const category of categories) {
            const newPath = [...currentPath, {
              categoryId: category.categoryId,
              categoryLabel: category.categoryLabel,
              routeName: category.useMain ? 'collectionCategoryMain' : 'collectionPage'
            }]

            if (category.categoryId === targetId) {
              path.push(...newPath)
              return true
            }

            if (category.subCategory && category.subCategory.length) {
              const found = findPath(category.subCategory, targetId, newPath)
              if (found) return true
            }
          }
          return false
        }

        findPath(categoryList, categoryId, [])
        return path
      }
      return getCategoryListAll && getBreadcrumbById(this.categoryId, getCategoryListAll)
    },
    nameSpacing () {
      const spacing = this.$store.getters['collection/getCommonItemStyle']
      return spacing && spacing.name && {
        letterSpacing: spacing.name
      }
    },
    isDirect () { // 상세페이지에서 이미지확대가 아니라 리스트에서 바로 갤러리
      return !this.collectionItemId
    },
    getPointColor () {
      return this.$store.getters['collection/getPointColor']
    },
    collectionSetting () {
      return this.$store.getters['collection/getCollectionSetting']
    },
    pageSetting () {
      const setting = this.collectionSetting
      const itemDetail = this.itemInfo && this.itemInfo.attribute
      return  {
        backgroundColor: setting.backgroundColor,
        color: itemDetail && itemDetail.detailColorActive ? itemDetail.detailTextColor : ''
      }
    },
    itemInfo () {
      const collectionItemId = this.collectionItemId
      return collectionItemId && this.$store.getters['collection/getItemByItemId'](collectionItemId)
    },
    detailItem () {
      const collectionItem = this.itemInfo
      const collectionCategory = collectionItem && this.$store.getters['collection/getCategoryById'](collectionItem.categoryIds[0])
      return collectionItem && {
        collectionItemName: collectionItem.collectionItemName,
        categoryName: collectionCategory && collectionCategory.categoryLabel,
        imageList: collectionItem.attribute && collectionItem.attribute.imageList
      }
    },
    imgIndicator () {
      return this.detailItem.imageList && this.detailItem.imageList.length > 1 ? {
        length: this.detailItem.imageList.length,
        color: this.getPointColor
      } : null
    },
  },
  mounted () {
    this.$nextTick(() => {
      const swiper = this.$refs.imageList.swiper
      if (swiper) {
        swiper.slideTo(0)
      }
    })
  },
  data() {
    return {
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: false,
        autoplay: false,
        threshold: 80,
        slidesPerView: 1
      }
    }
  },
  methods: {
    async toggleCollection () {
      const func = this.isMyCollection ? 'collection/removeMyCollectionItem' : 'collection/addCollection'
      const collectionCategory = this.getCategoryById.categorySetting.collectionCategory
      const data = {
        pageId: this.pageId,
        collectionCategory: collectionCategory,
        ...this.isMyCollection ? {
          orderItemId: this.collectionItemId
        } : {
          collectionItemId: this.collectionItemId
        }
      }
      this.$store.commit('loading', true)
      const res = await this.$store.dispatch(func, data)
      if (this.isMyCollection) {
        if (res && res.status === 200) {
          this.$store.commit('collection/setToastMessage', '내 콜렉션에서 삭제되었습니다.')
        }
      } else {
        if (res && res.result && res.result.orderUUID) {
          this.$store.commit('collection/setToastMessage', '내 콜렉션에 추가되었습니다.')
        }
      }
      this.$store.dispatch('collection/getMyCollectionItems', { pageId: this.pageId })
      this.$store.commit('loading', false)
    },
    close () {
      this.$store.commit('collection/setDetailGallery', null)
    }
  }
}
</script>
